const title = document.querySelector('#uare-title');

const boldWords = (number, item) => {
  const titleWords = item.getAttribute('data-title').split(' ');

  number === 1
    ? (item.innerHTML = titleWords
        .map((word, index) => (index === 0 ? `<strong>${word}</strong>` : word))
        .join(' '))
    : (item.innerHTML = titleWords
        .map((word, index) =>
          index < number ? `<strong>${word}</strong>` : word
        )
        .join(' '));
};

boldWords(2, title);
